<div appModal mainClass="lg-modal" (closeModal)="close()">
  <div class="form-container" [formGroup]="playInfoForm" *ngIf="showForm">
    <input type="hidden" formControlName="id" />

    <section class="modal-title-container">
      <div class="modal--title" translate [translateParams]="{ value: playInfo?.index, max: maxPlays }">
        SHARED.MODAL.HIGHLIGHT_REEL_PLAY_SELECT_MODAL.TITLE
      </div>
      <div class="modal--tabs">
        <button
          href=""
          class="btn btn-lg btn-text"
          [class.text-charcoal]="viewType === MODAL_TYPES.ADD_PLAY"
          (click)="selectType($event, MODAL_TYPES.ADD_PLAY, true)"
          translate
        >
          SHARED.MODAL.HIGHLIGHT_REEL_PLAY_SELECT_MODAL.ADD_PLAY
        </button>
        <button
          href=""
          class="btn btn-lg btn-text"
          [class.text-charcoal]="viewType === MODAL_TYPES.SELECT_CLIP || viewType === MODAL_TYPES.SELECT_CLIP_UPLOAD"
          (click)="selectType($event, MODAL_TYPES.SELECT_CLIP, true)"
          translate
        >
          SHARED.MODAL.HIGHLIGHT_REEL_PLAY_SELECT_MODAL.SELECT_CLIP
        </button>
      </div>
    </section>

    <section class="modal-content-container">
      <div class="form-data-container">
        <div
          class="game-thumbnail-container"
          *ngIf="!thumbnail && !video && viewType !== MODAL_TYPES.SELECT_CLIP_UPLOAD"
        >
          <img
            class="game-thumbnail-image"
            alt="Game image"
            src="/assets/images/highlight-reel/video-placeholder.jpg"
            srcset="
              /assets/images/highlight-reel/video-placeholder@2x.jpg 2x,
              /assets/images/highlight-reel/video-placeholder@3x.jpg 3x
            "
          />
        </div>

        <div
          class="game-thumbnail-container"
          *ngIf="thumbnail && !video && viewType !== MODAL_TYPES.SELECT_CLIP_UPLOAD"
        >
          <img
            class="game-thumbnail-image"
            [src]="thumbnail"
            appImgFallback="/assets/images/highlight-reel/video-placeholder.jpg"
            alt="Game image"
          />
          <div class="clip-info">
            <div *ngIf="playInfoForm?.value?.eventName" class="mb-1">{{ playInfoForm.value.eventName }}</div>
            <div *ngIf="playInfoForm?.value?.gameName" class="mb-1">{{ playInfoForm.value.gameName }}</div>
          </div>
        </div>

        <div class="game-thumbnail-container-video" *ngIf="video && viewType !== MODAL_TYPES.SELECT_CLIP_UPLOAD">
          <div
            class="game-thumbnail-image"
            *ngIf="video"
            video-player
            [videoId]="video.id"
            [video]="video"
            [controls]="false"
            [source]="video.url"
            [dontLoop]="false"
          ></div>

          <div class="clip-info">
            <div *ngIf="playInfoForm?.value?.clipName" class="mb-1">{{ playInfoForm.value.clipName }}</div>
            <div *ngIf="playInfoForm?.value?.clipEvent" class="mb-1">{{ playInfoForm.value.clipEvent }}</div>
            <div *ngIf="playInfoForm?.value?.clipGame" class="">{{ playInfoForm.value.clipGame }}</div>
          </div>
        </div>

        <input
          type="file"
          accept="video/*"
          name="video-upload"
          id="video-upload"
          #videoUpload
          (change)="fileChanged($event)"
        />

        <div
          class="thumbnail-container video-thumbnail-container"
          [class.file-loaded]="file"
          [class.file-drag]="fileDrag"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          *ngIf="!thumbnail && viewType === MODAL_TYPES.SELECT_CLIP_UPLOAD"
        >
          <ng-container *ngIf="!uploadingVideo && !videoUrl">
            <svg-icon src="/assets/images/svg/icons/misc/cloud-upload.svg"></svg-icon>
            <p class="upload-file-extensions">.&nbsp;MOV&nbsp;&nbsp;.&nbsp;MP4&nbsp;&nbsp;.&nbsp;MPEG</p>
            <p>Maximum file size is 5GB</p>
            <p class="text-gray">You can also attach by</p>
            <p class="underline text-blue mt-1 cursor-pointer" (click)="videoUpload.click()">clicking here</p>
          </ng-container>

          <ng-container *ngIf="uploadingVideo">
            <div class="loader mb-5" *ngIf="uploadingVideo">
              <div class="ball1"></div>
              <div class="ball2"></div>
              <div class="ball3"></div>
            </div>
            <p class="underline font-extrabold text-gray">Your video is uploading. Please wait.</p>
            <p class="font-extrabold text-gray" *ngIf="uploadProgress >= 0">{{ uploadProgress }}%</p>
          </ng-container>

          <ng-container *ngIf="!uploadingVideo && videoUrl">
            <img
              alt="Check"
              src="/assets/images/purchase-page/check.png"
              srcset="/assets/images/purchase-page/check@2x.png 2x, /assets/images/purchase-page/check@3x.png 3x"
            />
            <p class="underline font-extrabold text-gray">Video uploaded successfully</p>
          </ng-container>
        </div>

        <div
          class="input-group__fields"
          hr-game-select-form
          [userClips]="userClips"
          [selectClips]="this.viewType === MODAL_TYPES.SELECT_CLIP"
          [uploadClip]="this.viewType === MODAL_TYPES.SELECT_CLIP_UPLOAD"
          [playInfo]="playInfo"
          [playInfoForm]="playInfoForm"
          [userEvents]="userEvents"
          [readonly]="readonly"
          (uploadClipChange)="onUploadClipChange($event)"
        ></div>
      </div>
    </section>

    <section class="modal-actions-container">
      <button class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
      <button class="btn btn-lg" (click)="save()">Save</button>
    </section>
  </div>
</div>
